// ============================================
// eventTypeTags.js
// Auto-generated tags for each event type
// ============================================

// Common tags applied to ALL templates
export const COMMON_EVENT_TAGS = [
  'party',
  'fun',
  'invitation',
  'card',
  'greeting',
  'celebration',
  'event',
];

// Base tags for each event type
export const BASE_EVENT_TYPE_TAGS = {
  'Anniversary': ['anniversary', 'celebration', 'romantic', 'milestone', 'couple'],
  'Annual Function': ['annual', 'formal', 'organization', 'stage-event', 'celebration'],
  'Art Exhibition': ['art', 'exhibition', 'creative', 'gallery', 'culture'],
  'Baby Naming Ceremony': ['baby', 'naming', 'ceremony', 'family', 'traditional'],
  'Baby Shower': ['baby-shower', 'celebration', 'family', 'gifts', 'joyful'],
  'BBQ': ['bbq', 'outdoor', 'food', 'grill', 'casual'],
  'Beach Party': ['beach', 'party', 'summer', 'outdoor', 'fun'],
  'Birthday Party': ['birthday', 'celebration', 'party', 'fun', 'friends', 'bday', 'janamdin'],
  'Book Club Meetup': ['book-club', 'reading', 'discussion', 'community', 'casual'],
  'Bridal Shower': ['bridal-shower', 'wedding', 'bride', 'celebration', 'friends'],
  'Camping': ['camping', 'outdoor', 'nature', 'adventure', 'friends'],
  'Charity Event': ['charity', 'fundraiser', 'community', 'cause', 'giving'],
  'Christmas Party': ['christmas', 'festival', 'holiday', 'party', 'joyful'],
  'Cocktail Party': ['cocktail', 'party', 'drinks', 'social', 'evening'],
  'Community Gathering': ['community', 'gathering', 'social', 'local', 'together'],
  'Conference': ['conference', 'professional', 'networking', 'formal', 'industry'],
  'Concert': ['concert', 'music', 'live', 'entertainment', 'crowd'],
  'Cultural Event': ['cultural', 'tradition', 'performance', 'community', 'heritage'],
  'Diwali': ['diwali', 'festival', 'lights', 'celebration', 'traditional', 'deepavali'],
  'Dinner Party': ['dinner', 'party', 'food', 'social', 'evening'],
  'Eid': ['eid', 'festival', 'celebration', 'religious', 'family'],
  'Engagement Party': ['engagement', 'wedding', 'celebration', 'couple', 'family', 'sagai'],
  'Farewell Party': ['farewell', 'party', 'goodbye', 'memories', 'friends'],
  'Festival': ['festival', 'celebration', 'culture', 'crowd', 'fun'],
  'Festival Afterparty': ['afterparty', 'festival', 'party', 'nightlife', 'music'],
  'Freshers Party': ['freshers', 'college', 'party', 'youth', 'fun'],
  'Fundraiser': ['fundraiser', 'charity', 'cause', 'community', 'support'],
  'Game Night': ['games', 'fun', 'casual', 'friends', 'indoor'],
  'Graduation': ['graduation', 'achievement', 'milestone', 'celebration', 'students'],
  'Haldi': ['haldi', 'wedding', 'ceremony', 'traditional', 'family'],
  'Halloween Party': ['halloween', 'party', 'costume', 'fun', 'spooky'],
  'Hiking': ['hiking', 'outdoor', 'nature', 'adventure', 'fitness'],
  'Holiday Celebration': ['holiday', 'celebration', 'festival', 'family', 'joyful'],
  'Holi': ['holi', 'festival', 'colors', 'celebration', 'fun'],
  'Housewarming': ['housewarming', 'home', 'celebration', 'family', 'new-beginnings', 'griha-pravesh'],
  'Jagraata': ['jagraata', 'religious', 'devotional', 'night', 'community', 'jagran'],
  'Katha': ['katha', 'religious', 'spiritual', 'discourse', 'devotion'],
  'Karaoke Night': ['karaoke', 'music', 'fun', 'friends', 'night'],
  'Launch Party': ['launch', 'party', 'announcement', 'brand', 'celebration'],
  'Meet & Greet': ['meet-and-greet', 'networking', 'social', 'community', 'interaction'],
  'Mehendi': ['mehendi', 'wedding', 'ceremony', 'traditional', 'family', 'mehndi', 'henna'],
  'Movie Night': ['movie-night', 'entertainment', 'casual', 'friends', 'indoor'],
  'Music Festival': ['music', 'festival', 'concert', 'live', 'outdoor'],
  'Music Night': ['music', 'live', 'entertainment', 'night', 'social'],
  'Music Party': ['music', 'party', 'dance', 'dj', 'night'],
  'Networking Event': ['networking', 'professional', 'connections', 'career', 'social'],
  'New Year Party': ['new-year', 'party', 'celebration', 'night', 'countdown'],
  'Office Party': ['office-party', 'work', 'celebration', 'team', 'corporate'],
  'Open Mic': ['open-mic', 'performance', 'talent', 'creative', 'stage'],
  'Orientation': ['orientation', 'welcome', 'college', 'introduction', 'freshers'],
  'Paath': ['paath', 'religious', 'prayer', 'devotion', 'family'],
  'Photo Walk': ['photo-walk', 'photography', 'outdoor', 'creative', 'community'],
  'Picnic': ['picnic', 'outdoor', 'casual', 'friends', 'food'],
  'Pool Party': ['pool-party', 'summer', 'fun', 'party', 'water'],
  'Pooja': ['pooja', 'puja', 'religious', 'ritual', 'devotion', 'family'],
  'Potluck': ['potluck', 'food', 'community', 'sharing', 'casual'],
  'Reunion': ['reunion', 'friends', 'memories', 'together', 'celebration'],
  'Religious Ceremony': ['religious', 'ceremony', 'tradition', 'devotion', 'family'],
  'Road Trip': ['road-trip', 'travel', 'adventure', 'friends', 'fun'],
  'Sangeet': ['sangeet', 'wedding', 'music', 'celebration', 'family', 'dance'],
  'Seminar': ['seminar', 'learning', 'professional', 'knowledge', 'formal'],
  'Sports Viewing': ['sports', 'watch-party', 'fun', 'friends', 'live'],
  'Startup Pitch Event': ['startup', 'pitch', 'business', 'networking', 'innovation'],
  'Tea Party': ['tea', 'high-tea', 'social', 'afternoon', 'friends'],
  'Vacation': ['vacation', 'holiday', 'travel', 'trip', 'getaway'],
  'Vaccination': ['vaccination', 'baby', 'health', 'milestone', 'family'],
  'Wedding': ['wedding', 'ceremony', 'celebration', 'family', 'love', 'shaadi', 'vivah'],
  'Workshop': ['workshop', 'learning', 'skills', 'interactive', 'education'],
  'Wellness Session': ['wellness', 'health', 'mindfulness', 'relaxation', 'self-care'],
  'Yoga Session': ['yoga', 'wellness', 'fitness', 'mindfulness', 'health'],
};

/**
 * Get merged tags for an event type (base + common)
 * @param {string} eventType - The event type
 * @returns {string[]} - Array of all tags
 */
export const getEventTypeTags = (eventType) => {
  const baseTags = BASE_EVENT_TYPE_TAGS[eventType] || [];
  return Array.from(new Set([...baseTags, ...COMMON_EVENT_TAGS]));
};

/**
 * Get all event type tags merged with common tags
 * @returns {Object} - Object with event types as keys and merged tags as values
 */
export const EVENT_TYPE_TAGS = Object.fromEntries(
  Object.entries(BASE_EVENT_TYPE_TAGS).map(([eventType, tags]) => [
    eventType,
    Array.from(new Set([...tags, ...COMMON_EVENT_TAGS])),
  ])
);